/**
 * Safe localStorage wrapper.
 * Some browsers (in-app webviews, blocked cookies, private mode) throw a
 * SecurityError just for accessing window.localStorage. Never let that crash the app.
 */

const memoryStore = new Map<string, string>();

function getStore(): Storage | null {
  try {
    const ls = window.localStorage;
    // touch it to trigger a potential SecurityError early
    const probe = "__hb_probe__";
    ls.setItem(probe, "1");
    ls.removeItem(probe);
    return ls;
  } catch {
    return null;
  }
}

export const safeStorage = {
  getItem(key: string): string | null {
    const store = getStore();
    if (!store) return memoryStore.get(key) ?? null;
    try {
      return store.getItem(key);
    } catch {
      return memoryStore.get(key) ?? null;
    }
  },
  setItem(key: string, value: string): void {
    memoryStore.set(key, value);
    const store = getStore();
    if (!store) return;
    try {
      store.setItem(key, value);
    } catch {
      /* ignore */
    }
  },
  removeItem(key: string): void {
    memoryStore.delete(key);
    const store = getStore();
    if (!store) return;
    try {
      store.removeItem(key);
    } catch {
      /* ignore */
    }
  },
};
